import React from 'react'

import { dataStateProps } from '../..'
import * as S from './Info.styles'
import InfoItem from './InfoItem'

type InfoProps = {
  dataState: dataStateProps
}
const Info = ({ dataState }: InfoProps) => {
  const conversionRate =
    dataState.data?.open_count !== 0 && dataState.data
      ? (dataState.data?.total_purchased * 100) / dataState.data?.open_count
      : 0

  return (
    <S.CardsContainer>
      <InfoItem
        title="Aberturas de página"
        data={dataState.data?.open_count as number}
      />
      <InfoItem
        title="Contratações"
        data={dataState.data?.total_purchased as number}
      />
      <InfoItem
        title="Taxa de conversão"
        data={`${conversionRate.toFixed(2)}%`}
        tooltipTitle="Total de aberturas de página dividido pelo total de contratações."
        isPercentage
      />
    </S.CardsContainer>
  )
}

export default Info
